export default "__VITE_ASSET__Cmo_aCBH__"